export const TRADING_VIEW_SCRIPT_URL =
  'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
